<template>
    <div>
        <div class="flex-grid flex-grid--reduced-bottom-margin a-form-inputs p-general-damages" v-if="!longTextValue">
            <div class="flex-grid__item">
                <control :label="name ? 'Type of ' + name : 'Category of Injury'"
                         :tip-show="!!!name"
                         tip-text="This section is based on the General Damages 14th edition of the Judicial College Guidelines."
                         tip-icon="info"
                         tip-side="right"
                         tip-width="250"
                         tip-name="general_damages_award_narrative">
                    <select name="" v-model="injuryTypeId" v-field-control required @change="selectInjury()">
                        <option value="null" hidden>Please select...</option>
                        <option v-for="(category, index) in tree"
                                :value="index">
                            {{ category.index ? category.index : '' }} {{ category.name }}
                        </option>
                    </select>
                </control>
            </div>

            <div class="flex-grid__item  flex-grid--space-left">
                <div v-if="hasDescription()">
                    <h3>{{ tree[injuryTypeId]['name'] }}</h3> <br/>
                    <div v-html="tree[injuryTypeId]['description']"></div>
                </div>
            </div>
        </div>

        <div class="a-form-inputs p-general-damages p-general-damages__long-text" v-else>
            <label>{{name ? 'Type of ' + name : 'Category of Injury'}}</label>
            <div>
            <ul>
                <li v-for="(category, index) in tree">
                    <button class="a-button"
                            :class="[injuryTypeId  === index ? 'disabled' : '' ]"
                            @click="updateRadioButtons(index)">
                        <span v-if="injuryTypeId  === index">Selected</span>
                        <span v-else>Select Award</span>
                    </button>
                    <div class="a-radio u-d-none">
                        <input type="radio" :name="'injuryTypeRadio'+index" v-model="injuryTypeId" :value="index" @click="selectInjury()">
                    </div>
                    <p @click="updateRadioButtons(index)">{{ category.index ? category.index : '' }} <span v-html="category.name"></span></p>
                </li>
            </ul>
            </div>
        </div>

        <br/>
        <hr/>
        <br/>

        <injury-select ref="childSelect"
                       :level="( level + 1 )"
                       :selected="selected"
                       :awardIndex="awardIndex"
                       v-if="hasChildren()"
                       :tree="tree[injuryTypeId]['children']"
                       :name="tree[injuryTypeId]['name']"
                       v-on:injury-selected="bubbleSelected"
                       v-on:award-selected="updateValid"
                       :long-text-value="longText"
        ></injury-select>

        <div v-if="!hasChildren() && injuryTypeId !== null">
            <h2>The Range - JC Guidelines Chapter {{ getJCGuidelinesInfo(awardIndex) }}</h2>
            <div class="flex-grid flex-grid--reduced-bottom-margin u-margin-top-30 a-form-inputs p-general-damages">
                <div class="flex-grid__item--third">
                    <div class="flex-grid--column">
                        <h3>
                            With 10% Uplift
                        </h3>
                        <br/>
                        <span v-if="hasValue('up_to_value_with_uplift')">
                            Up to: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['up_to_value_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('in_the_region_of_with_uplift')">
                            In the region of: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['in_the_region_of_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('in_excess_of_with_uplift')">
                            In excess of: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['in_excess_of_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('a_few_hundred_pounds_to_with_uplift')">
                            A few hundred pounds to:  <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['a_few_hundred_pounds_to_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('not_less_than_with_uplift')">
                            Not less than: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['not_less_than_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('rarely_exceed_with_uplift')">
                            Rarely exceed: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['rarely_exceed_with_uplift']) }} </span>
                        </span>
                        <span v-else-if="hasValue('likely_to_exceed_with_uplift')">
                            Likely to exceed: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['likely_to_exceed_with_uplift']) }} </span>
                        </span>
                        <div v-else>
                            <span v-if="hasValue('lower_value_with_uplift')">
                                <!-- emitted from component on accordion range click -->
                                Lower Value: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['lower_value_with_uplift']) }} </span> to
                            </span>
                            <span v-if="hasValue('upper_value_with_uplift')">
                                <!-- emitted from component on accordion range click -->
                                Upper Value: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['upper_value_with_uplift']) }} </span>
                            </span>
                        </div>
                        <br/>
                        <button class="a-button" :disabled="uplift" :class="[uplift ? 'disabled' : '' ]" @click="adjustUplift()">
                            <span v-if="uplift">Selected</span>
                            <span v-else>Select</span>
                        </button>
                    </div>
                </div>
                <div class="flex-grid__item--third">
                    <div class="flex-grid--column">
                        <h3>
                            Without 10% Uplift
                        </h3>
                        <br/>
                        <span v-if="hasValue('up_to_value')">
                            Up to: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['up_to_value']) }} </span>
                        </span>
                        <span v-else-if="hasValue('in_the_region_of')">
                            In the region of: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['in_the_region_of']) }} </span>
                        </span>
                        <span v-else-if="hasValue('in_excess_of')">
                            In excess of: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['in_excess_of']) }} </span>
                        </span>
                        <span v-else-if="hasValue('a_few_hundred_pounds_to')">
                            A few hundred pounds to:  <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['a_few_hundred_pounds_to']) }} </span>
                        </span>
                        <span v-else-if="hasValue('not_less_than')">
                            Not less than: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['not_less_than']) }} </span>
                        </span>
                        <span v-else-if="hasValue('rarely_exceed')">
                            Rarely exceed: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['rarely_exceed']) }} </span>
                        </span>
                        <span v-else-if="hasValue('likely_to_exceed')">
                            Likely to exceed: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['likely_to_exceed']) }} </span>
                        </span>
                        <div v-else>
                            <span v-if="hasValue('lower_value')">
                                <!-- emitted from component on accordion range click -->
                                Lower Value: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['lower_value']) }} </span> to
                            </span>
                            <span v-if="hasValue('upper_value')">
                                <!-- emitted from component on accordion range click -->
                                Upper Value: <span class="u-bold"> {{ currencyFormat(tree[injuryTypeId]['upper_value']) }} </span>
                            </span>
                        </div>
                        <br/>
                        <button class="a-button" :disabled="!uplift" :class="[!uplift ? 'disabled' : '' ]" @click="adjustUplift()">
                            <span v-if="uplift">Select</span>
                            <span v-else>Selected</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="flex-grid a-form-inputs u-margin-top-10">
                <div class="flex-grid__item">
                    <h3 class="u-margin-bottom-20">General Damages</h3>
                    <control name="general_damages_award"
                                :tip-text="generalDamages === low || generalDamages === lowUplift ? 'This is the lower award.' :
                                generalDamages === mid || generalDamages === midUplift ? 'This is the mid-range between the lower and upper award.' :
                                generalDamages === upper || generalDamages === upperUplift ? 'This is the upper award.' : ''"
                                tip-icon="info"
                                tip-side="left"
                                tip-width="250"
                                tip-name="general_damages_award_narrative"
                                :tip-show="!!(low || lowUplift || upper || upperUplift)"
                                :no-flex-margin="true"
                                :table-control="true">
                        <div class="a-form-inputs--pound">
                            <input autocomplete="off" type="text" min="1" v-model.number="generalDamages"
                                    v-field-control required v-two-dp @change="updateValid">
                        </div>
                    </control>
                    <div>
                        <div v-if="hasValue('lower_value')">
                            <button class="a-button" :class="[generalDamages === low || generalDamages === lowUplift ? 'disabled' : '' ]" @click="applyAward('lower')">Apply Lower</button>
                            <button class="a-button" :class="[generalDamages === mid || generalDamages === midUplift ? 'disabled' : '' ]" @click="applyAward('mid')">Apply Mid</button>
                            <button class="a-button" :class="[generalDamages === upper || generalDamages === upperUplift ? 'disabled' : '' ]" @click="applyAward('upper')">Apply Upper</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Control from 'components/form/Control.vue';
    import {mapActions, mapGetters} from 'vuex';
    import currencyFormat from 'mixins/currencyFormat';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import IconTooltip from 'components/IconTooltip';


    export default {
        name: 'injury-select',
        beforeCreate: function () {
            this.$options.components.InjurySelect = require('./InjurySelect.vue').default
        },
        mixins: [
            currencyFormat,
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        watch: {
            'injuryTypeId'(newVal, oldValue) {
                this.$nextTick(() => {
                    this.selectInjury()
                });
            },
        },
        computed: {
            ...mapGetters('personal/generalDamages', {
                getUplift: 'getUplift',
                getGeneralDamages: 'getGeneralDamages',
                getJCGuidelinesInfo: 'getJCGuidelinesInfo'
            }),
            generalDamages: {
                get() {
                    return this.getGeneralDamages(this.awardIndex);
                },
                set(value) {
                    if (!value || value < 1){
                        value = 1.00;
                    }
                    this.updateValue({key: 'generalDamages', value, index: this.awardIndex}).then(() => this.$emit("award-selected", value));
                }
            },
            uplift: {
                get() {
                    return this.getUplift(this.awardIndex);
                },
                set(value) {
                    this.updateValue({key: 'uplift', value, index: this.awardIndex});
                },
            },
            low: {
                get() {
                    return this.tree[this.injuryTypeId]['lower_value'];
                }
            },
            lowUplift: {
                get() {
                    return this.tree[this.injuryTypeId]['lower_value_with_uplift'];
                }
            },
            mid: {
                get() {
                    return (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
                }
            },
            midUplift: {
                get() {
                    return (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2
                }
            },
            upper: {
                get() {
                    return this.tree[this.injuryTypeId]['upper_value'];
                }
            },
            upperUplift: {
                get() {
                    return this.tree[this.injuryTypeId]['upper_value_with_uplift'];
                }
            }
        },
        props: {
            tree: {
                type: Array,
                required: false
            },
            name: {
                type: String,
                required: false
            },
            selected: {
                required: true,
            },
            level: {
                type: Number,
                default: 0,
                required: true
            },
            longTextValue: {
                type: Boolean,
                default: false
            },
            awardIndex: {
                type: Number,
                required: true
            }
        },
        data: function () {
            return {
                injuryTypeId: typeof this.selected[this.level] !== 'undefined' ? this.selected[this.level] : null,
                award: 'mid',
                longText: false
            }
        },
        components: {
            Control,
            IconTooltip
        },
        methods: {
            ...mapActions('personal/generalDamages', {
                updateValue: 'updateValue',
                fetchInjuries: 'fetchInjuries',
                removeAward: 'removeAward'
            }),
            hasChildren() {
                if (this.injuryTypeId === null) {
                    return false;
                }

                if (typeof this.tree === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId]['children'] === 'undefined') {
                    return false;
                }

                if (this.tree[this.injuryTypeId]['children'].length === 0) {
                    this.calculateGeneralDamagesAverage();
                    return false;
                }

                _.each(this.tree[this.injuryTypeId].children, (branch) => {
                    if(branch.name.length > 100) {
                        this.longText = true;
                    }
                });

                return true;
            },
            hasValue(key) {
                if (this.injuryTypeId === null) {
                    return false;
                }

                if (typeof this.tree === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId][key] === 'undefined') {
                    return false;
                }

                if (this.tree[this.injuryTypeId][key] === null) {
                    return false;
                }
                return true;
            },
            hasDescription() {
                if (this.injuryTypeId === null) {
                    return false;
                }

                if (typeof this.tree === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId] === 'undefined') {
                    return false;
                }

                if (typeof this.tree[this.injuryTypeId]['description'] === 'undefined') {
                    return false;
                }

                if (this.tree[this.injuryTypeId]['description'] === '') {
                    return false;
                }
                return true;
            },
            calculateGeneralDamagesAverage() {
                if (this.generalDamages === null) {

                    let value = null;

                    if (this.hasValue('lower_value')) {
                        value = (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
                        if (this.uplift) {
                            value = (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2;
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('up_to_value')) {
                        value = this.tree[this.injuryTypeId]['up_to_value'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['up_to_value_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('in_the_region_of')) {
                        value = this.tree[this.injuryTypeId]['in_the_region_of'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['in_the_region_of_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('in_excess_of')) {
                        value = this.tree[this.injuryTypeId]['in_excess_of'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['in_excess_of_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('a_few_hundred_pounds_to')) {
                        value = this.tree[this.injuryTypeId]['a_few_hundred_pounds_to'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['a_few_hundred_pounds_to_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('not_less_than')) {
                        value = this.tree[this.injuryTypeId]['not_less_than'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['not_less_than_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('rarely_exceed')) {
                        value = this.tree[this.injuryTypeId]['rarely_exceed'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['rarely_exceed_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    } else if (this.hasValue('likely_to_exceed')) {
                        value = this.tree[this.injuryTypeId]['likely_to_exceed'];
                        this.award = 'lower';
                        if (this.uplift) {
                            value = this.tree[this.injuryTypeId]['likely_to_exceed_with_uplift'];
                            this.award = 'upper';
                        }
                        this.updateValue({key: 'generalDamages', value, index: this.awardIndex});
                        this.updateValid();
                        return value;
                    }
                }
            },
            updateRadioButtons(clickedRadio) {

                let radioButtons = document.querySelectorAll('.p-general-damages__long-text input[type="radio"]');

                radioButtons.forEach(element => {
                    element.checked = false;
                });

                radioButtons[clickedRadio].checked = true;

                this.injuryTypeId = clickedRadio;

                this.selectInjury();

            },
            selectInjury() {
                if(this.tree[this.injuryTypeId]) {

                    //reset the longText data value
                    this.longText = false;

                    _.each(this.tree[this.injuryTypeId].children, (branch) => {
                        if(branch.name.length > 100) {
                            this.longText = true;
                        }
                    });

                    if (this.hasChildren() && this.$refs.childSelect) {
                        this.$refs.childSelect.reset();
                    }

                    this.$emit("injury-selected", {
                        level: this.level,
                        value: this.injuryTypeId
                    });

                    this.resetAward();
                }
            },
            reset() {
                if (this.hasChildren() && this.$refs.childSelect) {
                    this.$refs.childSelect.reset();
                }

                this.injuryTypeId = null;
            },
            adjustUplift() {
                if (this.uplift) {
                    this.uplift = false;
                    this.updateValue({key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex});
                } else {
                    this.uplift = true;
                    this.updateValue({key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex});
                }

                this.updateValid();
            },
            applyAward(award) {
                this.award = award;
                this.updateValue({key: 'generalDamages', value: this.calculateAward(), index: this.awardIndex} );
                this.updateValid();
            },
            calculateAward() {
                switch(this.award) {
                    case 'lower':
                        if (this.uplift) {
                            return this.tree[this.injuryTypeId]['lower_value_with_uplift'];
                        }
                        return this.tree[this.injuryTypeId]['lower_value'];
                    case 'mid':
                        if (this.uplift) {
                            return (this.tree[this.injuryTypeId]['upper_value_with_uplift'] + this.tree[this.injuryTypeId]['lower_value_with_uplift']) / 2
                        }
                        return (this.tree[this.injuryTypeId]['upper_value'] + this.tree[this.injuryTypeId]['lower_value']) / 2;
                    case 'upper':
                        if (this.uplift) {
                            return this.tree[this.injuryTypeId]['upper_value_with_uplift'];
                        }
                        return this.tree[this.injuryTypeId]['upper_value'];
                }
            },
            resetAward() {
                this.updateValue({key: 'generalDamages', value: null, index: this.awardIndex});
            },
            bubbleSelected(val) {
                this.$emit("injury-selected", val);
            },
            updateValid() {
                this.$emit("award-selected");
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InjurySelect.vue?28d4f32c